var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('DxSelectBox',{staticClass:"dx-card wide-card",attrs:{"data-source":_vm.dataset,"value-expr":_vm.id,"display-expr":_vm.display,"placeholder":" Selecionar","show-clear-button":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }